import { t as tr } from "@/i18n";
import { useEffect, useState } from "react";
import { Check, Loader2, ShieldCheck, PenTool, ScanEye, BookOpenText } from "lucide-react";

const STEPS = [
  { icon: ShieldCheck, label: tr("checking_your_idea_is_kid_safe"), at: 0 },
  { icon: PenTool, label: tr("drawing_clean_line_art"), at: 2500 },
  { icon: BookOpenText, label: tr("writing_fun_facts_quiz"), at: 9000 },
  { icon: ScanEye, label: tr("safety_scanning_the_picture"), at: 16000 },
];

export const GenerationSteps = () => {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const start = Date.now();
    const t = setInterval(() => setElapsed(Date.now() - start), 300);
    return () => clearInterval(t);
  }, []);
  const active = STEPS.reduce((acc, s, i) => (elapsed >= s.at ? i : acc), 0);
  return (
    <ul className="space-y-3 w-full max-w-sm" data-testid="generation-steps">
      {STEPS.map((s, i) => {
        const done = i < active;
        const now = i === active;
        return (
          <li key={s.label} className={`flex items-center gap-3 p-3 rounded-2xl border-2 transition-colors duration-300 ${now ? "bg-white border-[#FFD166]" : done ? "bg-emerald-50 border-emerald-200" : "bg-white/50 border-transparent opacity-50"}`}>
            <span className={`w-9 h-9 rounded-xl flex items-center justify-center ${done ? "bg-emerald-400 text-white" : now ? "bg-[#FFD166]" : "bg-slate-100"}`}>
              {done ? <Check className="w-5 h-5" /> : now ? <Loader2 className="w-5 h-5 animate-spin" /> : <s.icon className="w-5 h-5" />}
            </span>
            <span className="font-bold text-sm">{s.label}</span>
          </li>
        );
      })}
    </ul>
  );
};
